import React from 'react'
import { Modal, Button } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useIntl } from 'react-intl'
import messages from './messages'

export default NiceModal.create(({ existingUsageTasks }) => {
  const modal = useModal()
  const { formatMessage } = useIntl()

  const handleChoice = (mode) => {
    modal.resolve({ mode })
    modal.remove()
  }

  const handleCancel = () => {
    modal.remove()
  }

  return (
    <Modal
      show={modal.visible}
      title={formatMessage(messages.title)}
      onClose={handleCancel}
      onOutsideClick={handleCancel}
      dialogPanelClasses="max-w-screen-sm"
    >
      <div className="my-4">
        <div className="grid grid-cols-2 gap-4">
          <Button
            state="primary"
            onClick={() => handleChoice('new')}
            className="w-full items-center"
          >
            <div className="font-semibold">
              {formatMessage(messages.newTask)}
            </div>
          </Button>

          <Button
            variant="outline"
            onClick={() => handleChoice('extension')}
            disabled={!existingUsageTasks || existingUsageTasks.length == 0}
            className="items-center"
          >
            <div className="font-semibold">
              {formatMessage(messages.extension)}
            </div>
          </Button>
        </div>

        {existingUsageTasks && existingUsageTasks.length == 0 && (
          <p className="text-sm text-gray-500 text-center">
            {formatMessage(messages.noExistingTasks)}
          </p>
        )}
      </div>
    </Modal>
  )
})
